var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStarOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.97 9.68a.592.592 0 00-.52-.41l-6.4-.55-2.5-5.92c-.19-.44-.92-.44-1.11 0l-2.5 5.92-6.39.55c-.24.02-.45.18-.52.41-.07.23 0 .48.18.64l4.85 4.21-1.45 6.26c-.05.23.04.48.23.62s.46.15.66.03l5.5-3.32 5.5 3.32c.1.06.2.09.31.09.12 0 .25-.04.35-.11.2-.14.29-.39.23-.62l-1.45-6.26 4.85-4.21c.19-.17.25-.42.18-.65zm-6.09 4.18c-.17.15-.24.37-.19.59l1.22 5.23-4.59-2.77a.586.586 0 00-.62 0l-4.6 2.76 1.22-5.23a.598.598 0 00-.19-.59l-4.06-3.51 5.34-.46c.22-.02.41-.16.5-.36L12 4.58l2.09 4.94c.09.21.28.35.5.36l5.34.46-4.05 3.52z"
  })));
}

export default SvgStarOutline;